import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';


class DividerView extends Component{

  render(){
    return(
      <Layout {...this.props} type="DividerView"/>
    )
  }
}

DividerView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};

export default DividerView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/DividerView.js